import { useRef, useState } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Home from './containers/Home';
import About from './containers/About';
import Skills from './containers/Skills';
import Works from './containers/Works';
import OtherProjects from './containers/OtherProjects';
import Contact from './containers/Contact';
import Footer from './components/Footer';

function App() {

  const [lightMode, setLightMode] = useState(false)
  const [menu, setMenu] = useState(false);

  const home = useRef(null)
  const about = useRef(null)
  const skills = useRef(null)
  const works = useRef(null)
  const contact = useRef(null)

  const scrollTo = (elementRef) => {
    window.scrollTo({
      top: elementRef.current.scrollIntoView(),
      behavior: 'smooth'
    })
  }

  return (
    <div className={(lightMode ? 'lightmode' : 'app')}>
      <div className="landing">
        <div className='others'>
          <div ref={home}>
            <Navbar menu={menu} setMenu={setMenu} home={home} skills={skills} works={works} contact={contact} about={about} scroll={scrollTo} lightMode={lightMode} setLightMode={setLightMode} />
            <Home scroll={scrollTo} works={works} lightMode={lightMode} />
          </div>
          <div ref={about}>
            <About lightMode={lightMode} />
          </div>
          <div ref={skills}>
            <Skills lightMode={lightMode} />
          </div>
          <div ref={works}>
            <Works lightMode={lightMode} />
            <OtherProjects lightMode={lightMode} />
          </div>
          <div ref={contact}>
            <Contact lightMode={lightMode} />
          </div>
          <Footer scroll={scrollTo} home={home} lightMode={lightMode} />
        </div>
      </div>
    </div>
  );
}

export default App;
